import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.system');
import { OnInit, OnDestroy, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-system',
template: templateSource || '',
    styles: [``],
})
export class PageAdminSystemComponent implements OnInit, OnDestroy, DoCheck {
    public PAGE: any;
    public ITEM: any;

    constructor(@Inject( Service) public service: Service) {
        if (!WizRoute.segment.page)
            return service.href("/admin/system/weathermap");
        this.PAGE = WizRoute.segment.page;
        this.ITEM = WizRoute.segment.item;
    }

    public async ngDoCheck() {
        if (this.PAGE != WizRoute.segment.page) {
            this.PAGE = WizRoute.segment.page;
            await this.service.render();
        }

        if (this.ITEM != WizRoute.segment.item) {
            this.ITEM = WizRoute.segment.item;
            await this.service.render();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin', '/');
        await this.service.render();
    }

}

export default PageAdminSystemComponent;